import { DocumentData, QueryDocumentSnapshot } from "@firebase/firestore";
import { FirebaseConverter } from "../../../firebase/firebaseConverter";
import {ClimbingEventRoutesResults, UserRoutes} from "../../../models/ClimbingEventRoutesResults";

export class EventRoutesResultConverter extends FirebaseConverter<ClimbingEventRoutesResults>{

    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>): ClimbingEventRoutesResults {
        const simplifiedResults = snapshot.data() as ClimbingEventRoutesResults

        simplifiedResults.userRoutes = new Map<string, UserRoutes>(Object.entries(simplifiedResults.userRoutes as any))

        return simplifiedResults;

    }
}